import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Menu, Container, Grid, Icon } from 'semantic-ui-react'
const { Column, Row } = Grid
import Entities from '~/crud/entities'
import { loadAuthUser } from '~/auth/actions'
import Profile from './profile'
import Helmet from 'react-helmet'
import OrganizationView from '~/organizationView'

let logo =
  'data:image/svg+xml;base64,PCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluICAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOmE9Imh0dHA6Ly9ucy5hZG9iZS5jb20vQWRvYmVTVkdWaWV3ZXJFeHRlbnNpb25zLzMuMC8iCiAgIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iMTMuNnB4IiBoZWlnaHQ9IjMwcHgiIHZpZXdCb3g9IjAgMCAxMy42IDMwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMy42IDMwOyIKICAgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+CiAgLnN0MHtmaWxsOiNGRkZGRkY7fQogIC5zdDF7b3BhY2l0eTowLjY7ZmlsbDojRkZGRkZGO30KICAuc3Qye29wYWNpdHk6MC44O2ZpbGw6I0ZGRkZGRjt9CiAgLnN0M3tvcGFjaXR5OjAuNDtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8ZGVmcz4KPC9kZWZzPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTMuNiw3TDYuOCwwdjkuMWw2LjgsN1Y3eiIvPgo8cG9seWdvbiBjbGFzcz0ic3QxIiBwb2ludHM9IjkuMSwxMS41IDguMSwxMi41IDguMSwyMS42IDEzLjUsMTYgIi8+Cjxwb2x5Z29uIGNsYXNzPSJzdDIiIHBvaW50cz0iMCwxNiA2LjgsOSA2LjgsMCAwLDcgIi8+Cjxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iNi44LDE0IDAsMjEgMCwzMCA2LjgsMjMgIi8+CjxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0wLDE2bDIuNCwyLjRMNi44LDE0bC0yLjQtMi40TDAsMTZ6Ii8+Cjwvc3ZnPgo='

let menuItems = [
  {
    path: '/organization',
    title: 'Organisaatiot',
  },
  {
    path: '/coordination',
    title: 'Koordinointi',
  },
  {
    path: '/task',
    title: 'Tehtävät',
  },
  {
    path: '/project',
    title: 'Projektit',
  },
  {
    path: '/interview',
    title: 'Haastattelut',
  },
  {
    path: '/file',
    title: 'Tiedostot',
  },
  {
    path: '/article',
    title: 'Artikkelit',
  },
  {
    path: '/list',
    title: 'Listat',
  },
  {
    path: '/order',
    title: 'Tilaukset',
  },
  {
    path: '/contact',
    title: 'Yhteyshenkilöt',
  },
  {
    path: '/settings/user',
    title: 'Käyttäjät',
    settings: true,
  },
  {
    path: '/settings/user_role',
    title: 'Käyttäjäroolit',
    settings: true,
  },
  {
    path: '/settings/product',
    title: 'Tuotteet',
    settings: true,
  },
  {
    path: '/settings/tasktype',
    title: 'Tehtävätyypit',
    settings: true,
  },

  {
    path: '/settings/invoice',
    title: 'Laskut',
    settings: true,
  },
  {
    path: '/settings/messagetemplates',
    title: 'Viestipohjat',
    settings: true,
  },
]

class AppWrapper extends Component {
  componentWillMount = () => {
    let { isLoggedIn, redirectToLogin } = this.props
    if (!isLoggedIn) redirectToLogin()
  }

  componentDidMount = () => {
    let { loadAuthUser, authUserLoading } = this.props
    if (authUserLoading) return
    loadAuthUser()
  }

  componentDidCatch = (err, info) => {
    console.error(err)
  }

  render() {
    let { children, location, user, goTo } = this.props
    let { pathname } = location

    let { admin = false, roleFeatures = [] } = user
    let isSettings = pathname.startsWith('/settings') && (admin || roleFeatures.includes('settings'))

    return (
      <div className="app-wrapper">
        <Helmet titleTemplate="%s - Kokemuksia Alusta" defaultTitle="Kokemuksia Alusta" />
        <div className="app-menu">
          <div className="app-menu-container">
            <div className="app-menu-left">
              <div className="app-menu-logo">
                <a href="/" onClick={e => e.preventDefault() & goTo('/organization')}>
                  <img src={logo} />
                </a>
              </div>
              <div className="app-menu-links">
                {isSettings ? (
                  <a
                    className="app-menu-link"
                    href="/organization"
                    onClick={e => e.preventDefault() & goTo('/organization')}>
                    <Icon name="chevron left" />
                  </a>
                ) : null}
                {menuItems.map(({ path, title, icon, settings = false }, key) => {
                  if (isSettings !== settings) return null

                  let classes = ['app-menu-link']
                  if (
                    (path === '/' && location.pathname === '/') ||
                    (path.length > 1 && location.pathname.startsWith(path))
                  )
                    classes.push('app-menu-link--active')
                  return (
                    <a
                      key={key}
                      className={classes.join(' ')}
                      href={path}
                      onClick={e => e.preventDefault() & goTo(path)}>
                      {title}
                    </a>
                  )
                })}
                {!isSettings && (admin || roleFeatures.includes('settings')) ? (
                  <a
                    className="app-menu-link"
                    href="/settings/user"
                    onClick={e => e.preventDefault() & goTo('/settings/user')}>
                    <Icon name="cogs" />
                  </a>
                ) : null}
              </div>
            </div>
            <div className="app-menu-right">{user ? <Profile /> : null}</div>
          </div>
        </div>
        <div className="app-content">{user ? children : 'Loading...'}</div>
        <OrganizationView />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    authUserLoading: state.authUserLoading,
    user: state.authUser,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    goTo: path => dispatch(push(path)),
    redirectToLogin: () => dispatch(push('/login')),
    loadAuthUser: () => dispatch(loadAuthUser()),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppWrapper))
